import type { ThemeColor } from '@vrplatform/theme';
import { Text, rem } from '@mantine/core';

export const PlaceholderBadge = ({
  children,
  color = 'neutral',
}: {
  children: React.ReactNode;
  color?: ThemeColor;
}) => {
  return (
    <Text
      component="span"
      display="inline-block"
      sx={(theme) => ({
        color: theme.colors[color][6],
        alignSelf: 'flex-start',
        backgroundColor: theme.colors[color][2],
        paddingBlock: rem(2),
        paddingInline: rem(8),
        borderRadius: theme.radius.lg,
        fontSize: theme.fontSizes.sm,
      })}
    >
      <span>{children}</span>
    </Text>
  );
};
